module.exports = __webpack_public_path__ + "static/media/Black Video.74c91c0a.mp4";